// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/anagrafiche/insegne/:id/clienti',
    requestBody: null,
    response: '{"success":true,"data":[{"id":12,"codice":"NOM00012","denominazione":"Bricocenter Italia S.r.l.","partitaIva":"01234567890","citta":"Milano","provincia":"MI","categoriaCliente":"CATENA_GDO","puntiVendita":4,"disattivato":false}]}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
